export default "__VITE_ASSET__2tqKxszU__"